import { TableCell } from "@material-ui/core";
import React from "react";
import { getDateAndTime } from "../../../services/commonMethods";

export default function DateColumn(props) {
  const { data, field, showDateOnly } = props;

  return <TableCell>{getDateAndTime(data[field], showDateOnly)}</TableCell>;
}
